import { Column } from 'react-table';
import { TableHeader, UserAvatar } from 'redesign';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  ShiftDetailBaseColumnDefinition,
  ShiftDetailCellBaseProps,
} from '../types/shift-detail-tables.types';
import { getFlexWorkerLabel } from '../../../../../../utils/get-flex-worker-label';

export const useGetShiftDetailsColumnDefinitionBase: () => Column<ShiftDetailBaseColumnDefinition>[] =
  () => {
    const { t } = useTranslation('hq-screen-specific');
    const flexWorkerImage: Column<ShiftDetailBaseColumnDefinition> = {
      Header: '',
      accessor: 'flexWorkerImage',
      Cell: FlexWorkerImageCell,
      width: '130px',
    };
    const fw: Column<ShiftDetailBaseColumnDefinition> = {
      Header: () => (
        <TableHeader>
          {t('work.table_headers.flexworker', { ns: 'hq-screen-specific' })}
        </TableHeader>
      ),
      accessor: 'flexWorkerFullName',
      Cell: FlexWorkerCell,
    };

    return [flexWorkerImage, fw];
  };

const FlexWorkerImageCell = ({
  value,
  onProfileClick,
}: ShiftDetailCellBaseProps<'flexWorkerImage'>) => {
  const {
    id,
    firstName,
    lastName,
    imageUrl,
    relation,
    partnerName,
    employmentType,
    hasCandidateLevel,
    isReplacement,
    lenderCompanyName,
  } = value;

  const label = getFlexWorkerLabel({
    employmentType,
    partnerName,
    hasCandidateLevel,
    isReplacement,
    lenderCompanyName,
  });

  return (
    <UserAvatar
      onClick={() => onProfileClick(id, relation)}
      firstName={firstName}
      lastName={lastName}
      imageUrl={imageUrl}
      avatarLabel={label}
    />
  );
};

const FlexWorkerCell = ({ value }: ShiftDetailCellBaseProps<'flexWorkerFullName'>) => {
  return (
    <Typography noWrap style={{ maxWidth: '240px' }}>
      {value}
    </Typography>
  );
};
